import { defineStore } from 'pinia';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    navDrawer: false,
    avatarMenu: false,
    logoutDialog: false,
  }),
  actions: {
    closeNavDrawer() {
      this.navDrawer = false;
    },
    toggleNavDrawer() {
      this.navDrawer = !this.navDrawer;
    },

    closeAvatarMenu() {
      this.avatarMenu = false;
    },
    toggleAvatarMenu() {
      this.avatarMenu = !this.avatarMenu;
    },

    openLogoutDialog() {
      this.logoutDialog = true;
    },
    closeLogoutDialog() {
      this.logoutDialog = false;
    },
  },
});
